<div class="advanced-settings">
  <div class="content">
    <div class="tabs-setting">
      <a  routerLink="/advanced-settings/profile" routerLinkActive="active">edit Profile</a>
      <a  routerLink="/advanced-settings/verify" routerLinkActive="active">verify</a>
    </div>
    <!-- <div class="content__title">Edit Profile</div> -->
    <div class="content__box">
      <div class="row">
        <div class="col-md-6">
          <label class="input">
            <input class="input__field" type="text" placeholder=" " [(ngModel)]="userInfo.profileCharacterName" />
            <span class="input__label">Character Name</span>
          </label>
        </div>
        <div class="col-md-6">
          <label class="input">
            <div class="position-relative" style="z-index: 60">
              <div value="" (clickOutside)="showAvatarDropdown = false"
                (click)="showAvatarDropdown = !showAvatarDropdown">
                @if(selectedAvatar){
                <div class="d-flex w-100 mx-1 justify-content-between" style="background-color: var(--white)">
                  <span>{{ selectedAvatar.title }}</span>
                  <span><img style="max-height: 3rem" class="shadow rounded"
                      [src]="compressedImagePath + selectedAvatar.image" /></span>
                </div>
                }@else{
                <div class="d-flex flex-column justify-content-center align-items-center">
                  <span class="pt-2"> Change Character Image <i class="fa fa-chevron-down"></i> </span>
                </div>
                }
              </div>
              <div class="d-flex flex-column position-absolute p-2 shadow rounded-sm"
                style="top: 100%; left: 0; background: var(--white)" *ngIf="showAvatarDropdown">
                <div *ngFor="let avatar of ROLES" (click)="selectedAvatar = avatar; onCharImageChange()" class="my-1">
                  <div class="d-flex w-100 mx-1 justify-content-between" style="background-color: var(--white)">
                    <span>{{ avatar.title }}</span>
                    <span><img style="max-height: 3rem" class="shadow rounded"
                        [src]="compressedImagePath + avatar.image" /></span>
                  </div>
                </div>
              </div>
            </div>
          </label>
        </div>
      </div>
      <ng-container *ngIf="charImage.preview">
        <div class="d-flex justify-content-center flex-column my-3">
          <label style="color: var(--primary)"><strong>Character Image Preview</strong></label>
          <img src="{{ charImage.preview }}" class="char-img-preview" alt="" />
        </div>
        <label class="input">
          <select class="input__field" [(ngModel)]="charImage.default">
            <option [value]="true">Character Image</option>
            <option [value]="false">Avatar</option>
          </select>
          <span class="input__label">Default Character Image</span>
        </label>
      </ng-container>
      <label class="input">
        <input class="input__field" type="text" minlength="6" maxlength="6"
          [ngStyle]="{ 'background-color': userInfo.numberOfDayForPostalCodeChange ? '#eee' : 'inherit' }"
          [disabled]="userInfo.numberOfDayForPostalCodeChange ? true : false" [(ngModel)]="postalCode"
          (ngModelChange)="filterSubregions()" />
        <span class="input__label">Postal Code {{ userInfo.numberOfDayForPostalCodeChange ? "- (" +
          userInfo.numberOfDayForPostalCodeChange + " days)" : "" }}</span>
      </label>
      <label class="input">
        <textarea class="input__field" type="text" placeholder=" " [(ngModel)]="userInfo.shortDescription"></textarea>
        <span class="input__label">Short Description</span>
      </label>
      <label class="input">
        <input class="input__field" [disabled]="true" style="background-color: #eee" type="text" placeholder=" "
          [(ngModel)]="userInfo.regionName" title="Select postal code to change region" />
        <!-- <app-multi-dropdown class="input__field p-0" [disabled]="true" [placeholder]="selectedMemberRegion"  [items]="regionList"   (itemSelected)="onRegionClick($event)"></app-multi-dropdown> -->
        <span class="input__label">Region</span>
      </label>
      <label class="input">
        <select2 class="input__field p-0" [data]="certifiedSelect" [multiple]="true" displaySearchStatus="always"
          (update)="updateCertificate($event)" ngDefaultControl [value]="userInfo.certifiedValue"> </select2>
        <span class="input__label">Certified</span>
      </label>
      <label class="input" *ngIf="showTheme">
        <select class="input__field" [value]="userInfo?.theme || 'space'" (change)="onThemeChange($event)">
          <option value="space">Space</option>
          <option value="beige">Beige</option>
          <option value="winter">Winter</option>
          <option value="bronze">Bronze</option>
        </select>
        <span class="input__label">Theme</span>
      </label>
      <label class="input">
        <select class="input__field" [(ngModel)]="userInfo.bgBody" (change)="onBgBodyChange($event)">
          <option [value]="">No Background</option>
          <!-- <option [value]="'bg-1'">Background 1</option> -->
          <option [value]="'bg-2'">Background 2</option>
        </select>
        <span class="input__label">Background Body</span>
      </label>
    </div>
    <button class="my-button-3 d-flex m-auto" (click)="saveProfileInfo()"><i class="fa-solid fa-save"></i>
      Save</button>
  </div>
</div>